import { useLogger } from '@omnia/ui/src/lib/hooks/useLogger'
import type { Member as OccMember } from '@vista-digital/ocapi-types/v1'
import { getMember, isMemberSignedIn } from '@vista-digital/occ-domain'
import { reaction } from 'mobx'
import { useEffect, useState } from 'react'

export const useGetMember = () => {
    const isSignedIn = isMemberSignedIn()
    const [member, setMember] = useState<Member | undefined>()
    const logger = useLogger('useMember')

    useEffect(() => {
        if (!isSignedIn) return

        /* to make `mobx` store to behave like a normal react state*/
        const dispose = reaction(
            () => getMember(),
            memberData => {
                if (!memberData) {
                    logger.warn('Member data is undefined after signIn')
                    return
                }

                const { familyName = '', givenName = '' } = memberData?.personalDetails.name || {}
                const initials = `${givenName?.[0] ?? ''}${familyName?.[0] ?? ''}`.toUpperCase()
                const fullName = `${givenName} ${familyName}`.trim()
                setMember({ ...memberData, initials, fullName })
            },
            { fireImmediately: true }
        )

        return () => dispose()
    }, [isSignedIn])

    return { isSignedIn, member }
}

// auto extends OCCMember interface
export interface Member extends OccMember {
    initials: string
    fullName: string
}
